import ManageAllSales from './ManageAllSales'
import ManageSalesByItem from './ManageSalesByItem'
import ManageTabs from './ManageTabs'

function ManageSales() {
  const labels = ['All Sales', 'Sales by Item']

  const panels = [<ManageAllSales />, <ManageSalesByItem />]

  return <ManageTabs title="Sales" labels={labels} panels={panels} />
}

export default ManageSales
